import { Chip, Stack } from "@mui/material";

export default function FilterChips({ filters, value, onChange }) {
  return (
    <Stack
      direction="row"
      spacing={1.5}
      flexWrap="nowrap"
      overflow="auto"
      sx={{
        pb: 0.5,

        "&::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      {filters?.map((filter) => (
        <Chip
          key={filter.value}
          label={filter.label}
          clickable
          onClick={() => onChange(filter.value)}
          color={value === filter.value ? "primary" : "default"}
          variant={value === filter.value ? "filled" : "outlined"}
          sx={{
            flexShrink: 0,
            borderRadius: "999px",
            fontWeight: 600,
            height: 40,
            px: 0.5,
            transition: "0.2s",
            "&:hover": {
              transform: "translateY(-1px)",
            },
          }}
        />
      ))}
    </Stack>
  );
}
